/**
 * Base filter bar component to get the filter value
 */
export class FilterCompositeComponent {

  title: string;
  id: string;

  /**
   * Returns criteria for search, can be any type
   */
  criteria(): string {
    return undefined;
  }

  /**
   * Clears the filter value
   */
  clear() {
    // nothing
  }

}
